import { render, staticRenderFns } from "./result-pagination.vue?vue&type=template&id=05c87524&scoped=true"
import script from "./result-pagination.vue?vue&type=script&lang=js"
export * from "./result-pagination.vue?vue&type=script&lang=js"
import style0 from "./result-pagination.vue?vue&type=style&index=0&id=05c87524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c87524",
  null
  
)

export default component.exports